<div class="circle-wrap" *ngIf="type==='circle'" [ngClass]="{'isPC': isPC,'isCamp':isCamp}" >
  <div class="ring" >
    <canvas id="tutorial"></canvas>
    <span class="fraction" *ngIf="progress===100"><span class="number"></span> <span class="fa fa-check"></span> <span class="redDot" *ngIf="redDot && isShowRedDot"></span></span>
  </div>
</div>


<div class="progressWrap {{theme.name}}" [ngClass]="{'haveTitle':theme.haveTitle}" *ngIf="type==='bar'">
  <div class="progress">
<!--    <div class="progress-inner"  [ngStyle]="{'width':progress+'%','background': theme.color,'border-radius':theme.radius}"></div>-->
    <div class="progress-inner-mark"></div>
    <div class="progress-inner"></div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/component-ui/progress-bar/component.progressBar.html